import actions from 'src/modules/workflowLaunch/list/workflowLaunchListActions';

const initialData = {
  rows: [],
  count: 0,
  loading: false,
  filter: {},
  rawFilter: {},
  selectedKeys: [],
  sorter: {},
  pagination: {
    current: 1,
    pageSize: 10,
  },
  exportLoading: false,
};

export default (state = initialData, { type, payload }) => {
  switch (type) {
    case actions.RESETED:
      return { ...initialData };

    case actions.SELECTEDS_CHANGED:
      return { ...state, selectedKeys: payload };

    case actions.PAGINATION_CHANGED:
      return { ...state, pagination: payload };

    case actions.SORTER_CHANGED:
      return { ...state, sorter: payload };

    case actions.FETCH_STARTED:
      return {
        ...state,
        loading: true,
        filter: payload?.filter || {},
        rawFilter: payload?.rawFilter || {},
        selectedKeys: payload?.keepPagination
          ? state.selectedKeys
          : [],
        pagination: payload?.keepPagination
          ? state.pagination
          : initialData.pagination,
      };

    case actions.FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        rows: payload.rows,
        count: payload.count,
      };

    case actions.FETCH_ERROR:
      return {
        ...state,
        loading: false,
        rows: [],
        count: 0,
      };

    case actions.EXPORT_STARTED:
      return { ...state, exportLoading: true };

    case actions.EXPORT_SUCCESS:
    case actions.EXPORT_ERROR:
      return { ...state, exportLoading: false };

    default:
      return state;
  }
};
